import { render, staticRenderFns } from "./usuario-bodega-movil.vue?vue&type=template&id=d765322e"
import script from "./usuario-bodega-movil.vue?vue&type=script&lang=js"
export * from "./usuario-bodega-movil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports